import Icon from "@ant-design/icons/lib/components/Icon";

import type { ReactElement, FC } from "react";
import type { CustomIconComponentProps as IProps } from "@ant-design/icons/lib/components/Icon";

const defaultIcon: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M3.33301 4.16699H16.663"
      stroke="#0E0E0E"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.3335 10H16.6668"
      stroke="#0E0E0E"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.33301 15.833H16.663"
      stroke="#0E0E0E"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default function HamburgerIcon(props: Partial<IProps>): ReactElement {
  return <Icon component={defaultIcon} {...props} />;
}
